import { Typography } from 'components'

const CardInfo = () => (
	<div>
		<div class='rounded-md border border-black-800 bg-black-850 p-5'>
			<Typography
				color='text-black-200'
				text='We use Código internally to prototype new types of Assistants before pushing them to production. It allows us to rapidly deploy our environment and test new features, ensuring they work seamlessly in mainnet.'
				variant='text2'
			/>
			<Typography
				class='mt-6'
				color='text-black-100'
				text='Jane Doe'
				variant='h5'
				weight='font-bold'
			/>
			<Typography
				class='mt-1'
				color='text-black-200'
				text='Co-founder, CONTOSO'
				variant='text2'
			/>
		</div>
	</div>
)

export { CardInfo }
